var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag_box",class:{ 'checkfield': _vm.isswitch },on:{"click":function($event){$event.stopPropagation();return _vm.toggle($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }